import { render, staticRenderFns } from "./ListNewslettersFeatured.vue?vue&type=template&id=e04b9790&scoped=true&"
import script from "./ListNewslettersFeatured.vue?vue&type=script&lang=js&"
export * from "./ListNewslettersFeatured.vue?vue&type=script&lang=js&"
import style0 from "./ListNewslettersFeatured.vue?vue&type=style&index=0&id=e04b9790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04b9790",
  null
  
)

export default component.exports